import HttpClient from '../HttpClient';
import HTTPResponse from '../HttpResponse';
import { ERRORS, type ErrorResponse } from '../errors';

class TimeSlot {
  private httpBokaCustomer: HttpClient;

  public constructor(httpBokaCustomer: HttpClient) {
    this.httpBokaCustomer = httpBokaCustomer;
  }

  public reserveTimeSlot = async (
    timeSlotId: string,
  ): Promise<HTTPResponse<unknown>> => {
    try {
      const url = `/timewindow/reserve/${timeSlotId}`;
      const reserveResponse = await this.httpBokaCustomer.post(url, {});

      return new HTTPResponse(reserveResponse);
    } catch (err) {
      const error: ErrorResponse = {
        status: ERRORS.CONFLICT,
        data: {
          statusCode: 'conflict',
        },
      };
      return new HTTPResponse('', error);
    }
  };

  public clearReservedTimeSlot = async (
    timeSlotId: string,
  ): Promise<HTTPResponse<unknown>> => {
    try {
      const url = `/timewindow/reserve/${timeSlotId}`;
      const reserveResponse = await this.httpBokaCustomer.delete(url);

      return new HTTPResponse(reserveResponse);
    } catch {
      return new HTTPResponse('');
    }
  };
}

export default TimeSlot;
